export default data => ({ type: 'UPDATE_COMPILED_THEME', data });
